import React from "react";

import { ITextParamTypeDescriptor } from "../../database/interfaces/paramScript/IParamTypeDescriptor";
import TextFieldInput from "../../common/inputs/TextFieldInput";

/**
 * Text property card content component.
 */
interface ITextCardContentProps {
    typeDescriptor: ITextParamTypeDescriptor;
    paramValue: string;
    onUpdateParamValue: (value: string) => void;
}

const TextCardContent: React.FC<ITextCardContentProps> = ({ typeDescriptor, paramValue, onUpdateParamValue }) => {
    return typeDescriptor && (
        <TextFieldInput
            label={typeDescriptor.label}
            value={paramValue ? paramValue : (typeDescriptor.default as string || "")}
            tooltip={typeDescriptor.tooltip}
            placeholder={typeDescriptor.placeholder}
            editable={typeDescriptor.editable ?? false}
            readOnly={typeDescriptor.readOnly ?? false}
            multiline={typeDescriptor.multiline}
            onValueChange={onUpdateParamValue}
        />
    );
}

export default TextCardContent;
